import { render, staticRenderFns } from "./RunsAdmin.vue?vue&type=template&id=084f050d&scoped=true"
import script from "./RunsAdmin.vue?vue&type=script&lang=js"
export * from "./RunsAdmin.vue?vue&type=script&lang=js"
import style0 from "./RunsAdmin.vue?vue&type=style&index=0&id=084f050d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f050d",
  null
  
)

export default component.exports